import { BrowserProvider, Contract, Interface } from "ethers";
import { useEffect, useState } from "react";
import {
  fromDecimalData,
  getContractAddress,
  getSimpleAddress,
} from "../common/helper";
import { StakingService } from "../openapi";
import STAKING_ABI from "../common/STAKING_ABI.json";
import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { useNavigate } from "react-router-dom";

type Props = {
  apy: number;
};

export const RecentStakingCard = ({ apy }: Props) => {
  const navigate = useNavigate();

  const { walletProvider } = useWeb3ModalProvider();

  const [stakings, setStakings] = useState<any[]>([]);

  useEffect(() => {
    StakingService.listStakings(apy, 0, 5)
      .then(async (res) => {
        let stakings = [];
        for (let i = 0; i < res[0].length; i++) {
          stakings.push({
            ...res[0][i],
            reward: await getTotalReward(res[0][i].stakingID),
          });
        }
        setStakings(stakings);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [apy]);

  const getTotalReward = async (id: number) => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const staking = new Contract(
        getContractAddress(apy)!,
        new Interface(STAKING_ABI).format(false),
        signer
      );

      const reward = parseFloat(
        fromDecimalData(await staking.getTotalReward(id))
      );

      return reward;
    } catch (err) {
      console.log(err);

      return 0;
    }
  };

  return (
    <div className="col-span-12 xxl:col-span-4">
      <div className="box overflow-hidden">
        <div className="box-header">
          <div className="sm:flex justify-between space-y-2 sm:space-y-0">
            <h5 className="box-title my-auto">
              Recent Stakings ( APY : {apy} )
            </h5>
            <div className="block ltr:ml-auto rtl:mr-auto my-auto">
              <button
                type="button"
                className="ti-btn m-0 rounded-sm p-1 px-3 !border border-gray-200 text-gray-400 hover:text-gray-500 hover:bg-gray-200 hover:border-gray-200 focus:ring-gray-200  dark:hover:bg-black/30 dark:border-white/10 dark:hover:border-white/20 dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
                onClick={() => navigate("/staking/" + apy)}
              >
                View All
              </button>
            </div>
          </div>
        </div>
        <div className="box-body p-0 activity-table">
          <div className="overflow-auto">
            <table className="ti-custom-table ti-custom-table-head">
              <thead className="">
                <tr>
                  <th scope="col" className="min-w-[200px]">
                    Address
                  </th>
                  <th scope="col text-center">Amount</th>
                  <th scope="col text-center">Reward</th>
                </tr>
              </thead>
              <tbody>
                {stakings.map((staking, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">
                        {getSimpleAddress(staking.account, 8)}
                      </td>
                      <td className="text-center">{staking.amount} UPC</td>
                      <td className="text-center">{staking.reward} UPC</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
